/**
 * @file
 * A JavaScript file containing the carousel functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.globalProgress = {
    attach: function (context) {
      $(document).ready(function() {
        $('.GlobalProgress', context).once('global-progress').each(function () {
          const root = this;
          const map = root.querySelector(".GlobalProgress-map");
          const listeners = root.querySelectorAll(`[data-country-id]`);
          const ee = new EventEmitter();
          let carousel = null;

          if (window.matchMedia("(min-width: 760px)").matches) {
            carousel = tns({
              container: root.querySelector(".GlobalProgress-countriesList"),
              mode: "carousel",
              axis: "vertical",
              loop: false,
              mouseDrag: true,
              items: 8,
              nav: false,
              controlsPosition: "bottom",
              controlsContainer: root.querySelector(".GlobalProgress-countriesListControls")
            });
          } else {
            carousel = tns({
              container: root.querySelector(".GlobalProgress-countriesList"),
              mode: "carousel",
              axis: "horizontal",
              center: true,
              loop: false,
              mouseDrag: true,
              items: 3,
              nav: false,
              controlsPosition: "bottom",
              controls: false
            });
          }

          const updateGlobalProgress = (targetId) => {
            listeners.forEach(listener => listener.classList.remove("is-active"));

            const targets = root.querySelectorAll(`[data-country-id="${targetId}"]`);
            targets.forEach(target => {
              target.classList.add("is-active");

              if (target.classList.contains("GlobalProgress-hotspot")) {
                const targetCoords = target.getBoundingClientRect();

                map.scroll({
                  top: targetCoords.top,
                  left: parseFloat(window.getComputedStyle(target).left) - (window.innerWidth / 2) + (targetCoords.width / 2) + parseFloat(window.getComputedStyle(root).paddingLeft),
                  behavior: "smooth"
                });
              }

              const countriesList = target.closest(".GlobalProgress-countriesList");
              if (countriesList) {
                const item = target.closest("li");
                const itemIndex = [].indexOf.call(countriesList.children, item);
                carousel.goTo(itemIndex);
              }
            });
          };

          ee.on("global-progress:update", updateGlobalProgress);

          listeners.forEach(listener => {
            listener.addEventListener("click", (e) => {
              ee.trigger("global-progress:update", [listener.getAttribute("data-country-id")])
            });
          });
        });
      });
    }
  }
})(Drupal, jQuery);
